import { IanaTimezone, TimezoneOption } from "../types";

export const DEFAULT_TIMEZONE = "UTC" as IanaTimezone;

const buildTimezoneOptions = (): TimezoneOption[] => {
  const utcEntry: TimezoneOption = {
    value: "UTC" as IanaTimezone,
    label: "UTC",
    region: "Universal"
  };

  const ianaTimezones = Intl.supportedValuesOf("timeZone");

  const options: TimezoneOption[] = ianaTimezones.map((tz) => {
    const segments = tz.split("/");
    const region = segments[0];
    const lastSegment = segments[segments.length - 1];
    const label = lastSegment.replace(/_/g, " ");

    return {
      value: tz as IanaTimezone,
      label,
      region
    };
  });

  options.sort((a, b) => {
    const regionCompare = a.region.localeCompare(b.region);
    if (regionCompare !== 0) {
      return regionCompare;
    }
    return a.label.localeCompare(b.label);
  });

  return [utcEntry, ...options];
};

export const TIMEZONE_OPTIONS: TimezoneOption[] = buildTimezoneOptions();

const deriveTimezoneRegions = (): string[] => {
  const regionSet = new Set(TIMEZONE_OPTIONS.map((option) => option.region));
  return Array.from(regionSet);
};

export const TIMEZONE_REGIONS = deriveTimezoneRegions();

export type TimezoneRegion = string;

export const IANA_TIMEZONE_PATTERN = /^[A-Za-z_-]+\/[A-Za-z_-]+(?:\/[A-Za-z_-]+)?$|^UTC$/;

export const isValidIanaTimezone = (value: string): value is IanaTimezone =>
  TIMEZONE_OPTIONS.some((option) => option.value === value);

export const getTimezoneByValue = (value: string): TimezoneOption | undefined =>
  TIMEZONE_OPTIONS.find((option) => option.value === value);

export const getTimezonesByRegion = (region: TimezoneRegion): TimezoneOption[] =>
  TIMEZONE_OPTIONS.filter((option) => option.region === region);
